import React from 'react';
import AfterLoginLayout from '../AfterLoginLayout/AfterLoginLayout';
import PlanSelection from './PlanSelection';

const PlanSelectionPage: React.FC = () => {
  return <AfterLoginLayout children={<PlanSelection />} />;
};

export default PlanSelectionPage;
